export const SCHEMA_VERSION = '1.6.0';
